import { Injectable } from "@angular/core";

import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { environment } from "environments/environment";
import { catchError, map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })
export class WhatsappDeliveryService {
  public url = `${environment.apiUrl}/private`;
  private deliveryWhatsapp = `${this.url}/message-delivery/whatsapp`;
  private baseUrl = `${environment.apiUrl}/private/whatsapp-accounts`;

  private messageSentSubject: Subject<void> = new Subject<void>();

  constructor(
    private readonly _toastr: ToastrService,
    private readonly http: HttpClient
  ) {}

  getWhatsappAccount(companyId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/find-company-account/${companyId}`);
  }

  updateWhatsAppUserAccount(companyId: number, user: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/update-whatsapp-user/${companyId}`, user);
  }

  sendSingularWhatsapp = (whatsapp): Observable<any> =>
    this.http
      .post(`${this.deliveryWhatsapp}/singular`, whatsapp)
      .pipe(
        map((res) => {
          this._toastr.success("Whatsapp enviado");
          return res;
        })
      )
      .pipe(
        catchError((error) => {
          console.error("Error al enviar whatsapp", error);
          if (error.cause === "web_send_not_allowed")
            this._toastr.warning(
              error.details.error,
              "No tiene permitido enviar por web"
            );
          else if (error.cause === "subscription_plan_consumed")
            this._toastr.warning(error.details.error, "Producto consumido");
          else if (error.cause === "plan_not_allowed_product_the_send_type")
            this._toastr.warning(error.details.error, "Envío no permitido");
          else if (error.cause === "in_blackout_range")
            this._toastr.warning(error.details.error, "Horario fuera de linea");
          else if (
            error.cause === "recipient_is_blacklisted" ||
            error.details?.message === "recipient_is_blacklisted"
          )
            this._toastr.warning(error.details.error, "Número bloqueado");
          else if (error.cause === "limit_was_reached")
            this._toastr.warning(error.details.error, "Límite alcanzado");
          else if (error.cause === "limit_does_not_exist")
            this._toastr.warning(error.details.error, "Límite no existe");
          else if (error.cause === "can_send_by_web_inavailable")
            this._toastr.warning(error.details.error);
          else if (
            error.details?.message === "message_does_contain_blocked_word"
          )
            this._toastr.warning(
              "El mensaje contiene palabras bloqueadas o no permitidas"
            );
          else if (
            error.details.message === "message_does_not_contain_required_words"
          )
            this._toastr.warning(
              "El mensaje no contiene ninguna de las palabras requeridas"
            );
          else this._toastr.error("Ocurrió un error al enviar el mensaje");

          throw error;
        })
      );

  sendSingularWhatsappChat = (whatsapp): Observable<any> =>
    this.http
      .post(`${this.deliveryWhatsapp}/singular`, whatsapp)
      .pipe(
        map((res) => {
          this._toastr.success("Whatsapp enviado");

          this.messageSentSubject.next();

          return res;
        })
      )
      .pipe(
        catchError((error) => {
          console.error("Error al enviar whatsapp", error);
          if (error.cause === "subscription_plan_consumed")
            this._toastr.warning(error.details.error, "Producto consumido");
          if (error.cause === "plan_not_allowed_product_the_send_type")
            this._toastr.warning(error.details.error, "Envío no permitido");
          else if (error.cause === "in_blackout_range")
            this._toastr.warning(error.details.error, "Horario fuera de linea");
          else if (error.cause === "limit_was_reached")
            this._toastr.warning(error.details.error, "Límite alcanzado");
          else if (error.cause === "limit_does_not_exist")
            this._toastr.warning(error.details.error, "Límite no existe");
          else if (error.cause === "number_is_blacklisted")
            this._toastr.warning(error.details.error, "Número bloqueado");
          else this._toastr.error("Error al enviar el mensaje");

          throw error;
        })
      );

  onMessageSent(): Observable<void> {
    console.log('mensaje');
    return this.messageSentSubject.asObservable();
  }

  getWhatsappSenders = (companyId?: number): Observable<any> => {
    let url = `${this.url}/whatsapp-accounts/channels`;
    
    if (companyId) {
      url += `?company_id=${companyId}`;
    }
    
    return this.http.get(url).pipe(
      catchError((err: HttpErrorResponse) => {
        console.error("Error al obtener canales", err);
        throw err;
      })
    );
  };

  sendFile = (fileId: number): Observable<any> =>
    this.http.post(`${this.deliveryWhatsapp}/bulk-file/${fileId}`, {});

}
